import React from "react";
import "./footer.css";
import { IconType } from "react-icons";
import { FaFacebookSquare, FaInstagram } from "react-icons/fa";

type SocialIconProps = {
  Icon: IconType;
  className?: string;
  size?: number;
};

const SocialIcon = ({ Icon, className }: SocialIconProps) => {
  return <>{Icon({ className })}</>;
};

const Footer: React.FC = () => {
  return (
    <footer id="colophon" className="site-footer">
      <div className="footer-box">
      {/* ================= DESKTOP / TABLET ================= */}
      <div className="vc_row style-color-gyho-bg tablet-hidden mobile-hidden">
        <div className="row limit-width exa-top-padding exa-bottom-padding">
          <div className="row-inner footer-grid">

            {/* Contacto */}
            <div className="footer-col">
              <h4 className="footer-title">Contacto</h4>
              <p>
                <span className="text-green">Antofagasta 3424</span><br />
                <span className="text-green">Estación Central, RM, Chile.</span><br />
                <a className="footer-email" href="mailto:contacto@parquedelosgasometros.cl">
                  contacto@parquedelosgasometros.cl
                </a>
              </p>
            </div>

            {/* Espacio vacío (como en el original) */}
            <div className="footer-col" />

            {/* Facebook */}
            <div className="footer-col footer-social right">
              <a
                href="https://www.facebook.com/parquedelosgasometros/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialIcon Icon={FaFacebookSquare} className="footer-icon" />
              </a>
            </div>

            {/* Instagram */}
            <div className="footer-col footer-social">
              <a
                href="https://www.instagram.com/parquedelosgasometros/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialIcon Icon={FaInstagram} className="footer-icon" />
              </a>
            </div>

          </div>
        </div>
      </div>

      {/* ================= MOBILE ================= */}
      <div className="vc_row style-color-gyho-bg desktop-hidden">
        <div className="row limit-width exa-top-padding exa-bottom-padding">
          <div className="row-inner footer-grid-mobile">

            <div className="footer-col">
              <h4 className="footer-title">Contacto</h4>
              <p>
                Antofagasta 3424<br />
                Estación Central, RM, Chile.<br />
                <a className="footer-email" href="mailto:contacto@parquedelosgasometros.cl">
                  contacto@parquedelosgasometros.cl
                </a>
              </p>
            </div>

            <div className="footer-col footer-social">
              <a
                href="https://www.instagram.com/parquedelosgasometros/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialIcon Icon={FaFacebookSquare} className="footer-icon" />
              </a>
            </div>
            <div className="footer-col footer-social">
              <a
                href="https://www.instagram.com/parquedelosgasometros/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialIcon Icon={FaInstagram} className="footer-icon" />
              </a>
            </div>

          </div>
        </div>
      </div>

      </div>

    </footer>
  );
};

export default Footer;
